export enum PaymentModalSteps {
  ChooseMethodOfPayment,
  EnterAmount,
  LCDStep,
  LCDAmountStep,
  EnterBillingAddress,
  EnterPaymentInformation,
  PaymentComplete,
  PaymentCompleteZeroDue,
}

export enum PaymentBillingAddressValidationSteps {
  ValidatingAddress,
  UnverifiedAddress,
  SelectValidAddress,
  DeniedAddress,
}

export enum AmountSelection {
  TotalAmountDue = 'totalAmountDue',
  DifferentAmount = 'differentAmount',
}

export type LcdAmountSelection =
  | 'payTotalAmountDue'
  | 'payTotalAmountOwed'
  | 'enterDifferentAmount'

export const initialAmountOption = AmountSelection.TotalAmountDue
export const initialLCDAmountOption: LcdAmountSelection = 'payTotalAmountDue'
